<template>
  <Dialog
    v-if="visibleDialog"
    v-model:visible="visibleDialog"
    :style="{ width: '1200px' }"
    :header="`Eventos solicitados`"
    :modal="true"
    @hide="hideDialog"
    class="p-fluid"
  >
    <DataTable
      ref="dt"
      dataKey="id"
      class="p-datatable-sm"
      :value="list"
      :paginator="true"
      :rows="10"
      :filters="filters"
      :rowsPerPageOptions="[10, 20, 50]"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} eventos"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      :loading="loading"
    >
      <template #empty>
        <div class="p-text-center">Nenhum resultado encontrado...</div>
      </template>
      <Column field="id" header="#" :sortable="true">
        <template #body="slotProps">
          <span class="p-column-title">#</span>
          {{ slotProps.data.id }}
        </template>
      </Column>
      <Column field="local.name" header="Local" :sortable="true">
        <template #body="slotProps">
          <span class="p-column-title">Local</span>
          {{ slotProps.data.local.name }}
        </template>
      </Column>
      <Column field="name" header="Nome" :sortable="true">
        <template #body="slotProps">
          <span class="p-column-title">Nome</span>
          <div class="p-text-uppercase">{{ slotProps.data.name }}</div>
        </template>
      </Column>
      <Column field="pae" header="Pae" :sortable="true">
        <template #body="slotProps">
          <span class="p-column-title">Pae</span>
          {{ slotProps.data.pae }}
        </template>
      </Column>
      <Column field="type" header="Tipo" :sortable="true">
        <template #body="slotProps">
          <span
            :class="
              'evento-badge status-' + $Util.formatType(slotProps.data.type)
            "
            >{{ $Util.formatType(slotProps.data.type) }}</span
          >
        </template>
      </Column>
      <Column field="dtCreated" header="Data de Cadastro" :sortable="true">
        <template #body="slotProps">
          <span class="p-column-title">Data de Cadastro</span>
          {{ $DateTime.formatarDateTime24hours(slotProps.data.dtCreated) }}
        </template>
      </Column>
      <Column field="dtEvento" header="Data do Evento">
        <template #body="slotProps">
          <span class="p-column-title">Data do Evento</span>
          <div v-if="slotProps.data.calendars.length > 0">
            <div
              v-if="
                this.$DateTime.formatarDate(
                  slotProps.data.calendars[0].date
                ) ===
                this.$DateTime.formatarDate(
                  slotProps.data.calendars[slotProps.data.calendars.length - 1]
                    .date
                )
              "
            >
              {{
                this.$DateTime.formatarDate(slotProps.data.calendars[0].date)
              }}
            </div>
            <div v-else>
              {{
                this.$DateTime.formatarDate(slotProps.data.calendars[0].date)
              }}
              -
              {{
                this.$DateTime.formatarDate(
                  slotProps.data.calendars[slotProps.data.calendars.length - 1]
                    .date
                )
              }}
            </div>
          </div>
        </template>
      </Column>
      <Column field="status" header="Status">
        <template #body="slotProps">
          <span class="p-column-title">Status:</span>
          <span
            :class="
              'evento-badge status-' +
              $Util.formatEventStatus(slotProps.data.status)
            "
            >{{ $Util.formatEventStatus(slotProps.data.status) }}</span
          >
        </template>
      </Column>
      <Column header="Ações">
        <template #body="slotProps">
          <Button
            icon="pi pi-check"
            class="p-button-rounded p-button-info mr-2"
            v-if="slotProps.data.status === 'REQUESTED'"
            v-tooltip.left="'Agendar Evento.'"
            @click="showSchedule(slotProps.data)"
          />
          <Button
            icon="pi pi-times"
            class="p-button-rounded p-button-danger mr-2"
            v-tooltip.left="'Cancelar Evento.'"
            v-if="
              slotProps.data.status === 'REQUESTED' ||
              slotProps.data.status === 'SCHEDULE'
            "
            @click="showCancel(slotProps.data)"
          />
        </template>
      </Column>
    </DataTable>
    <template #footer>
      <Button
        label="Fechar"
        icon="pi pi-times"
        class="p-button p-button-text"
        @click="hideDialog"
      />
    </template>
  </Dialog>
  <dialog-cancel-vue :objSelected="obj" @findAll="findAllRequestedEvents" />
  <ConfirmDialog></ConfirmDialog>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
//Models
import Event from "../../../models/internal/event";
//services
import EventService from "../../../service/internal/event/event_service";

//components
import DialogCancelVue from "../../event/components/dialog-cancel.vue";

export default {
  components: {
    DialogCancelVue,
  },
  data() {
    return {
      obj: new Event(),
      list: [],
      service: new EventService(),
      filters: {},
      loading: false,
    };
  },
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.event.dialogRequesteds;
        if (value === true) this.findAllRequestedEvents();
        return value;
      },
      set(value) {
        this.$store.state.views.event.dialogRequesteds = value;
      },
    },
  },
  created() {
    this.initFilters();
  },
  methods: {
    findAllRequestedEvents() {
      this.loading = true;
      this.service
        .searchByStatusOrName(`status=REQUESTED&name=""`)
        .then((data) => {
          this.list = data;
          this.loading = false;
        });
    },
    hideDialog() {
      this.obj = new Event();
      this.list = [];
      this.$emit("findAll");
      this.visibleDialog = false;
    },

    showSchedule(event) {
      this.$confirm.require({
        message: 'Confirma o agendamento do Evento: "' + event.name + '"?',
        header: "Confirmação",
        icon: "pi pi-calendar",
        acceptLabel: "Sim",
        rejectLabel: "Não",
        accept: () => {
          this.scheduleEvent(event);
        },
      });
    },

    scheduleEvent(event) {
      event.status = "SCHEDULE";
      this.service
        .update(event)
        .then((data) => {
          if (data.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: "Alerta!",
              detail: "Evento agendado com sucesso.",
              life: 3000,
            });
            this.findAllRequestedEvents();
          }
        })
        .catch((error) => {
          this.findAllRequestedEvents();
          this.$msgErro(error);
        });
    },
    showCancel(event) {
      this.obj = event;
      this.$store.state.views.event.dialogCancel = true;
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.fc-sticky {
  cursor: pointer;
}
</style>
